import React from 'react';
import { flatten } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './index.module.scss';
import { formatAddress } from '../../utils/formatAddress';

const JobRequestSummary = ({ data, byCategory }) => {
  const {
    service, notes, address, isASAP, date, time
  } = data;

  const services = service != null ? service.map((el) => (
    flatten(Object.values(byCategory)).find((item) => item.job_service_id === el)
  )) : null;
  const appointment = isASAP ? 'As soon as possible' : `${date ? date.calendar() : moment().calendar()} at ${time ? time.format('h:mm A') : ''}`;

  return (
    <div className={styles.summaryContainer}>
      <div className={styles.title}>Appointment</div>
      <div className={styles.value}>{appointment}</div>
      {services
        && (
          <>
            <div className={styles.title}>Description</div>
            <div className={styles.value}>{`${services[0].job_sub_category_name}, ${services.map((el) => ` ${el.job_service_name}`)}`}</div>
          </>
        )}
      <div className={styles.title}>Address</div>
      <div className={styles.value}>{formatAddress(address)}</div>
      <div className={styles.title}>Notes</div>
      <div className={styles.value}>{notes}</div>
    </div>
  );
};

JobRequestSummary.propTypes = {
  data: PropTypes.shape({
    occupation_name: PropTypes.string,
    occupation_id: PropTypes.number,
    business_name: PropTypes.string,
    service: PropTypes.array,
    notes: PropTypes.string,
    address: PropTypes.object,
    isASAP: PropTypes.bool,
    date: PropTypes.instanceOf(Date),
    time: PropTypes.object,
  }),
  byCategory: PropTypes.object,
};

export default JobRequestSummary;
